import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("gabs_lang") || "fr";
        } catch {
            return "fr";
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem("gabs_lang", lang);
        } catch {
            /* noop */
        }
        document.documentElement.lang = lang;
    }, [lang]);

    const t = (key) => {
        const dict = translations[lang] || translations.fr;
        return key.split(".").reduce((obj, k) => (obj && obj[k] != null ? obj[k] : null), dict) ?? key;
    };

    return (
        <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
    );
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useI18n must be used within I18nProvider");
    return ctx;
}
